import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import Hls from 'hls.js'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './App'

// react-player will load hls.js from jsdelivr.net unless we preload it like this
window.Hls = Hls

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <App/>
)
